export default "__VITE_ASSET__uVtcnvP6__"